export default __webpack_public_path__ + "static/media/tracer-smarts.dd95f288.mp3";